module.exports = __webpack_public_path__ + "img/m-bottom2.0.1.0_202602051651.png";